const fallbackRouteName = 'Directful Dashboard'

const routeNames = {
  analytics: 'Reports overview',
  users: 'Users',
  addUser: 'Add user',
  paymentLink: 'Payment link',
  userPermissions: 'User management',
  audit: 'Audit',
  selectHotel: 'Select hotel',
  addGuestData: 'Add guest data',
  guestList: 'Guest list',
  activeGuests: 'Active guests',
  uploadLogs: 'Upload logs',
  manageCampaigns: 'Manage follow-ups',
  guestDetails: 'Guest details',
  addTelecom: 'Add telecom',
  onboarding: 'Onboarding',
  operaSetup: 'Opera setup',
  reviews: 'Reviews',
  reviewDetails: 'Review details',
  invoice: 'Invoice',
  statement: 'Statement',
  transaction: 'Transactions',
  billing: 'Billing',
  onBoarding: 'Onboarding',
  hotels: 'Hotels',
  messaging: 'During-stay messaging',
  incoming: 'Before-stay messaging',
  hotel: 'Hotel details',
  manageBilling: 'Billing management',
  arrivals: 'Arrivals',
  tutorial: 'Tutorial',
  newHotel: 'New hotel',
  editHotel: 'Edit hotel',
  insights: 'Insights',
  analyzeResults: 'Analyze results',
  aiTraining: 'AI training',
  notificationPreferences: 'Notification preferences',
  announcements: 'Announcements'
}

function getRouteName(pathName) {
  let cleanUrl

  try {
    cleanUrl = pathName.match(/^\/([^/]+)/)[1]
  } catch (error) {
    cleanUrl = null
  }
  const match = routeNames[cleanUrl]

  return match ? `${match} | Directful Dashboard` : fallbackRouteName
}

export default getRouteName
